import { Navigate, useParams } from "react-router-dom";
import { Routes } from "../../../routes/RouteConstants";
import { useTenant } from "../../../contexts/TenantContext";
import { findProvider, saveProviderChoice } from "../providerChoice";

/**
 * `/providers/:providerId`, the link a provider shares, on Instagram say: the choice is made, and
 * the guest lands on that provider's services. An id the tenant does not list leads to the choice
 * page; a tenant with one provider has nothing to choose and goes straight to its services.
 */
const ProviderLinkPage = () => {
  const { providers, hasSeveralProviders } = useTenant();
  const provider = findProvider(providers, Number(useParams().providerId));

  if (!hasSeveralProviders) return <Navigate to={Routes.SUPPLY} replace />;
  if (!provider) return <Navigate to={Routes.PROVIDERS} replace />;

  saveProviderChoice(provider.id);
  return <Navigate to={Routes.SUPPLY} replace />;
};

export default ProviderLinkPage;
